// Lightweight, cookie-free conversion tracking.
// Pushes to window.dataLayer (ready for GA/Matomo later) and logs to backend
// (structured logging) — no external tracking cookies are set in this sprint.

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const trackEvent = (name, props = {}) => {
  // Skip all side-effects during react-snap prerendering.
  if (typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap") return;
  try {
    // 1) dataLayer push — a future GA/Matomo tag can consume this
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...props, ts: Date.now() });

    // 2) structured server-side logging (fire-and-forget, never blocks UI)
    if (BACKEND_URL) {
      fetch(`${API}/track`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, props }),
        keepalive: true,
      }).catch(() => {});
    }
  } catch (_) {
    /* tracking must never break the UI */
  }
};

// Named event constants to keep call sites consistent
export const EVENTS = {
  PRODUCT_CARD_CLICK: "product_card_click",
  CTA_DISCUSS: "cta_discuss_citizen",
  CTA_ASSESSMENT: "cta_request_assessment",
  PDF_DOWNLOAD: "pdf_download",
  CONTACT_SUBMIT: "contact_form_submit",
  CONTACT_FORLOEB_SELECT: "contact_forloeb_selected",
  FINDER_STARTED: "forloeb_finder_started",
  FINDER_STEP: "forloeb_finder_step_completed",
  FINDER_COMPLETED: "forloeb_finder_completed",
  FINDER_RECOMMENDATION: "forloeb_finder_recommendation",
  FINDER_CONTACT_CLICK: "forloeb_finder_contact_click",
  FINDER_RESTART: "forloeb_finder_restart",
  FINDER_PDF_DOWNLOAD: "forloeb_finder_pdf_download",
  COMMISSIONER_PAGE_VIEW: "commissioner_page_view",
  COMMISSIONER_CTA_CLICK: "commissioner_cta_click",
  COMMISSIONER_PDF_DOWNLOAD: "commissioner_pdf_download",
  COMMISSIONER_FAQ_OPEN: "commissioner_faq_open",
  COMMISSIONER_CONTACT_STARTED: "commissioner_contact_started",
  COMMISSIONER_CONTACT_SUBMITTED: "commissioner_contact_submitted",
  COMMISSIONER_FINDER_CLICK: "commissioner_pathway_finder_click",
  SERVICE_AREA_CONTACT_CLICK: "service_area_contact_click",
};
